import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { DiscountManagementService } from "../../_services/discount-management.service";

@Component({
  selector: "dev-endpoint-example",
  template: `
    <div class="relative">
      <div
        dir="rtl"
        style="top:  -110px;"
        class="absolute  menu-limiter flex flex-row items-center justify-center gap-9"
      >
        <input
          type="text"
          class="form-control w-64 max-w-64 mt-2"
          placeholder="חיפוש"
          [(ngModel)]="searchQuery"
        />

        <button
          (click)="callSearchEvents()"
          class="app-button px-6"
          type="button"
        >
          <span>ארועי אב</span>
        </button>
      </div>
    </div>
  `,
  styleUrls: ["../development.component.scss"],
})
export class DevEndpointExampleComponent {
  public translations$: Observable<ITranslations>;
  public searchQuery: any;

  constructor(
    private translationService: TranslationService,
    private discountManagementService: DiscountManagementService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public async callSearchEvents() {
    console.time("parentEvents");
    await this.discountManagementService.searchParentEventForNewSubsidyByText(
      "123"
    );
    console.timeEnd("parentEvents");
  }
}



// WEBPACK FOOTER //
// ./src/app/development/example/dev-endpoint-example.component.ts